// Human-readable labels for charts and tables.

/** "2026-09-27" -> "27 Sep". Unparseable input is returned unchanged. */
export function shortDate(iso: string): string {
  const d = new Date(`${iso.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

/** "insufficient_data" / "lowEngagement" -> "Insufficient data" / "Low engagement". */
export function humanize(key: string): string {
  if (!key) return key;
  const spaced = key.replace(/[_-]+/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').trim().toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/** Apex x-axis for a date series: short labels that never overlap. */
export function dateXAxis(dates: string[]) {
  return {
    categories: dates.map(shortDate),
    tickAmount: Math.min(dates.length, 7),
    labels: { rotate: 0, hideOverlappingLabels: true, trim: true },
  };
}
